export enum PartnerRole {
    APP,
    PAR
}